import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

// * Buttons can have multiple sizes
// * Buttons can have an icon or no icon

// TODO Setup hover states to effect icon colors, and allow scaling to be even with icons enabled

export const defaultStyles = css`
  position: relative;
  display: block;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  border-radius: 28px;
  background-color: ${themeGet('colors.pc-red', '#E1251B')};
  color: ${themeGet('colors.white', '#FFF')};
  font-weight: ${themeGet('fontWeights.normal')};
  line-height: 48px;
  font-size: 1rem;
  padding: 0 1.25rem;
  text-align: center;
  white-space: nowrap;
  min-height: 48px;
  min-width: 160px;
  max-width: 315px;
  width: fit-content;
  z-index: 0;
  text-overflow: ellipsis;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    // * This fixes IE align-items: center bug
    height: 48px;
  }

  & > span {
    padding-bottom: 0;
    border-bottom: none;
    font-weight: inherit;
    color: currentColor;
  }

  :hover,
  :focus {
    text-decoration: underline;
    background-color: ${themeGet('colors.tertiary-red', '#C1211B')};

    // * Radial gradient hover animation, keeping for posterity sake
    /* &::after {
      content: '';
      transform: scale(2);
    } */

    & > svg {
      color: ${themeGet('colors.white', '#FFF')};
      transform: translate(2px, -2px);
    }
  }

  :focus {
    outline-color: ${themeGet('colors.tertiary-red', '#C1211B')};
  }
`;

export const IconStyles = css`
  &::before,
  &::after {
    content: '';
    width: 14px;
    height: 14px;
    margin-left: 5px;
    margin-right: 5px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    display: inline-block;
    flex: 0 0 auto;
  }
`;

export const ButtonStyles = css`
  &.btn-primary {
    // * Radial gradient hover animation, keeping for posterity sake
    /* &::after {
      content: '';
      position: absolute;
      margin: 0 auto;
      background-color: ${themeGet('colors.tertiary-red', '#C1211B')};
      width: 200px;
      height: 200px;
      border-radius: 100%;
      transform: scale(0);
      transition: transform 1s ease;
      z-index: -1;
    } */

    ${defaultStyles}
  }

  &.btn-primary-inverse {
    ${defaultStyles}
    color: ${themeGet('colors.pc-red', '#E1251B')};
    background-color: ${themeGet('colors.white', '#FFF')};

    :hover,
    :focus {
      color: ${themeGet('colors.tertiary-red', '#C1211B')};
      background-color: ${themeGet('colors.light-grey', '#F6F6F7')};

      & > svg {
        color: ${themeGet('colors.tertiary-red', '#C1211B')};
      }
    }

    :focus {
      outline-color: ${themeGet('colors.light-grey', '#F6F6F7')};
    }
  }

  &.btn-border {
    ${defaultStyles}
    color: ${themeGet('colors.pc-red', '#E1251B')};
    background-color: ${themeGet('colors.white', '#FFF')};
    outline: 2px solid ${themeGet('colors.pc-red', '#E1251B')};
    outline-offset: -2px;

    :hover,
    :focus {
      color: ${themeGet('colors.tertiary-red', '#C1211B')};
      background-color: ${themeGet('colors.light-grey', '#F6F6F7')};

      & > svg {
        color: ${themeGet('colors.tertiary-red', '#C1211B')};
      }
    }

    :focus {
      outline-color: ${themeGet('colors.tertiary-red', '#C1211B')};
    }
  }

  &:disabled {
    ${defaultStyles}
    cursor: not-allowed;
    box-shadow: none;
    color: ${themeGet('colors.secondary-text', '#686868')};
    background-color: ${themeGet('colors.light-border-grey', '#E8E9EB')};
    outline: 2px solid ${themeGet('colors.secondary-text', '#686868')};
    outline-offset: -2px;

    & > svg {
      color: currentColor;
    }

    &:hover,
    &:focus {
      cursor: not-allowed;
      text-decoration: none;
      color: ${themeGet('colors.secondary-text', '#686868')};
      background-color: ${themeGet('colors.light-border-grey', '#E8E9EB')};

      & > svg {
        transform: none;
        color: currentColor;
      }
    }
  }

  &.short {
    min-height: 36px;
    min-width: 140px;

    &:lang(fr) {
      min-width: 160px;
    }
  }

  ${({ icon }) => (icon ? `${IconStyles}` : '')};

  &::after {
    content: ${({ placement }) => (placement === 'false' ? '' : `none`)};
    mask: ${props => props.icon && `url(${props.icon})`};
    mask-size: cover;
    background-color: currentColor;
    transform: ${({ isActive }) => (isActive ? 'rotate(-180deg)' : 'none')};
  }

  &::before {
    content: ${({ placement }) => (placement === 'true' ? '' : `none`)};
    mask: ${props => props.icon && `url(${props.icon})`};
    mask-size: cover;
    background-color: currentColor;
    transform: ${({ isActive }) => (isActive ? 'rotate(-180deg)' : 'none')};
  }
`;

export const Btn = styled.button.attrs(() => ({
  type: 'button',
}))`
  ${ButtonStyles}
`;
